import NftLogo from '../../src/legacy/NftLogo';
export default NftLogo;
